export const permissions = {
  CREATE_ORGANIZATION: '6413f4aee95df589e64896e5',
  MANAGE_ORGANIZATIONS_AND_INFORMATION: '641006b16c27e21dff67e334',
  MANAGE_ORGANIZATION_ADMINS: '641006c16c27e21dff67e335',
  MANAGE_ORGANIZATION_SUBADMINS: '6413f531e95df589e64896e7',
  MANAGE_ORGANIZATION_PROFILES: '641006c86c27e21dff67e336',
  MANAGE_SYSTEM_SUBADMINS: '6413f480e95df589e64896e4',
  MOVE_PROFILES: '6413f4d6e95df589e64896e6'
};
